import React, { FC } from 'react';

import classNames from 'classnames';

import { EvSection, EvTitle } from '@evinced-private/ui-common';

import {
	WFA_DASHBOARD_PAGE_USAGE_SECTION_ID,
	WFA_DASHBOARD_PAGE_USAGE_TITLE_ID
} from 'data-automation-ids/WfaDashboardAutomationIds';
import { SummaryLineSkeleton } from 'src/apps/wfa/components/skeletons/summary-line-skeleton/SummaryLineSkeleton';
import { SummaryPane } from 'src/common/components/summary-pane/SummaryPane';
import { getUsageDataTooltipText } from 'src/common/helpers/TooltipContentHelper';
import { SummaryItem } from 'src/common/interfaces/SummaryItem';

import './WfaSessionsUsage.scss';

interface IWfaDashboardUsageSectionProps {
	data: SummaryItem[];
	isLoading: boolean;
	selectedPeriodLabel?: string;
}

export const WfaSessionsUsage: FC<IWfaDashboardUsageSectionProps> = ({
	data,
	isLoading,
	selectedPeriodLabel = 'All Sessions'
}) => {
	return (
		<EvSection
			ariaLabel="Last month usage"
			skipLinkId="usage-section"
			className={classNames('dashboard-section', 'wfa-sessions-usage')}
			ariaLive="polite"
			dataAutomationId={WFA_DASHBOARD_PAGE_USAGE_SECTION_ID}
		>
			<EvTitle
				titleText="Summary"
				headingLevel={2}
				className="page-heading"
				dataAutomationId={WFA_DASHBOARD_PAGE_USAGE_TITLE_ID}
				MoreInfoContent={
					// MoreInfoContent is a React Element that doesn't accept string,
					// Copied this solution from mfa
					// eslint-disable-next-line react/jsx-no-useless-fragment
					<>{getUsageDataTooltipText('sessions')}</>
				}
			/>
			<EvTitle
				titleText={`Showing data from ${selectedPeriodLabel.toLowerCase()}`}
				headingLevel={3}
				className="page-subheading"
			/>
			{isLoading ? (
				<SummaryLineSkeleton animationSpeed={0} />
			) : (
				<SummaryPane
					items={data}
					shouldHaveSkipLink={false}
					className="base-summary-pane"
					ariaLabel="Last month usage summary"
				/>
			)}
		</EvSection>
	);
};
